import { Checkbox } from "primereact/checkbox";
import { useAppSelector } from "../../../../../../stateManagement/hooks/redux";
import { useDispatch } from "react-redux";
import { setCustomMapAppliedFilters, setCustomMapFiltersState } from "../../../../../../stateManagement/reducers/custom/CustomMapSlice";
import axios from "axios";
import { useEffect } from "react";
import { getItemWebStorage, setItemWebStorage } from "../../../../../../features/webStorageSaver";
import { authorizeToCustomRest } from "../../../../../../features/customAuth/customAuth";

export default function CustomFilterListCheckbox({ fieldName, objectTypeName }: any) {
    const dispatch = useDispatch()
    const filtersState = useAppSelector(state => state.customMap.customMapFiltersState)
    const appliedFilters = useAppSelector(state => state.customMap.customMapAppliedFilters)
    const restAuthToken = useAppSelector(state => state.customAuth.customAuthToken)

    const { listValues, hasSearch, nullFilterValue, ignoreFilterValue, searchValue, nullable } = filtersState[fieldName]
    const captionFilter = (caption: any) => caption?.toLowerCase().includes(searchValue.toLowerCase())
    const listSearchFilter = (listValue: any) => listValue?.caption?.toLowerCase().includes(searchValue.toLowerCase())

    useEffect(() => {
        if (restAuthToken) {
            const savedFiltersState = getItemWebStorage(`customMapFiltersState-${objectTypeName}`)
            if (!savedFiltersState?.[fieldName]?.listValues) {
                fillInitFilterListCheckboxValues(restAuthToken)
            }
        }
    }, [restAuthToken])

    // применение фильтра со значением List-Checkbox
    function applyFilterListCheckboxValue(checkBoxValue: string, checked: boolean, fieldName: string) {
        let filterStateListValues: any = [...filtersState[fieldName].listValues]
        let ignoreFilterValue = { ...filtersState[fieldName]?.ignoreFilterValue }
        let nullFilterValue = { ...filtersState[fieldName]?.nullFilterValue }
        let appliedFiltersListValue = { [checkBoxValue]: checked }
        if (checkBoxValue == `ignore-${fieldName}`) {
            ignoreFilterValue.checked = checked
        }
        else {
            // выключение IgnoreField при нажатии на любое значение отличное от IgnoreField
            ignoreFilterValue.checked = false
            appliedFiltersListValue = { ...appliedFiltersListValue, [`ignore-${fieldName}`]: false }
            if (checkBoxValue == `null-${fieldName}`) {
                nullFilterValue.checked = checked
            } else {
                // новый массив объектов значений для состояния фильтров
                filterStateListValues = filterStateListValues.map((item: any) => item.value === checkBoxValue ? { ...item, checked } : { ...item })
            }
        }
        let newFiltersFieldState = {
            ...filtersState[fieldName],
            listValues: filterStateListValues,
            ignoreFilterValue
        }
        if (nullable) {
            newFiltersFieldState = { ...newFiltersFieldState, nullFilterValue }
        }
        // новое состояние фильтров
        let newFiltersState = {
            ...filtersState,
            [fieldName]: newFiltersFieldState
        }
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
        // новые примененные фильтры
        let newAppliedFilters = {
            ...appliedFilters,
            [fieldName]: {
                ...appliedFilters[fieldName],
                listValues: {
                    ...appliedFilters[fieldName]?.listValues,
                    ...appliedFiltersListValue
                }
            }
        }
        dispatch(setCustomMapAppliedFilters(newAppliedFilters))
        setItemWebStorage(`customMapAppliedFilters-${objectTypeName}`, newAppliedFilters)
    }

    function setSearchValue(value: string, fieldName: string) {
        let newFiltersState = structuredClone(filtersState)
        newFiltersState[fieldName].searchValue = value
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
    }

    async function fillInitFilterListCheckboxValues(authToken: any) {
        let newFiltersState = structuredClone(filtersState)
        const listValuesFromSource = getItemWebStorage(`customMapFiltersListValues-${objectTypeName}`) ?? {}
        let newListValuesFromSource = structuredClone(listValuesFromSource)
        const { listValuesSource } = filtersState[fieldName]
        if (listValuesSource) {
            let listValues
            if (newListValuesFromSource[fieldName]) {
                listValues = newListValuesFromSource[fieldName]
            }
            else {
                listValues = await getListValuesFromSource(listValuesSource, authToken)
                if (listValues?.error === 401) {
                    return
                }
            }
            newFiltersState[fieldName].listValues = listValues
            newListValuesFromSource = { ...newListValuesFromSource, [fieldName]: listValues }
        }
        setItemWebStorage(`customMapFiltersListValues-${objectTypeName}`, newListValuesFromSource)
        dispatch(setCustomMapFiltersState(newFiltersState))
        setItemWebStorage(`customMapFiltersState-${objectTypeName}`, newFiltersState)
    }

    async function getListValuesFromSource(listValuesSource: any, authToken: any) {
        const { url, propertyForCaption, propertyForValue, fetchPlan, sort } = listValuesSource
        let customUrl = url
        if (fetchPlan || sort) {
            let queryParameters = []
            if (fetchPlan) {
                queryParameters.push(`fetchPlan=${fetchPlan}`)
            }
            if (sort) {
                queryParameters.push(`sort=${sort}`)
            }
            customUrl += `?${queryParameters.join('&')}`
        }
        try {
            const response = await axios.get(customUrl, {
                headers: {
                    "Authorization": `Bearer ${authToken}`
                }
            });
            const valuesArray = response.data
            let listValues = valuesArray.map((item: any) => {
                return {
                    caption: item[propertyForCaption],
                    value: item[propertyForValue],
                    checked: false
                }
            })
            return listValues
        } catch (error: any) {
            if (error?.response?.status === 401) {
                const restAuthRequestOptions = getItemWebStorage('currentConfig')?.mapAdditionalItems?.find((item: any) => item?.objectType === objectTypeName)?.restAuthRequestOptions
                await authorizeToCustomRest(restAuthRequestOptions)
                return { error: 401 }
            }
        }
    }

    return (
        <div className="filter-list-checkbox">
            <div className="map-hint-filters-checkbox-div">
                <Checkbox
                    inputId={`ignore-${fieldName}`}
                    name={`ignore-${fieldName}`}
                    onChange={(event: any) => applyFilterListCheckboxValue(`ignore-${fieldName}`, event.checked, fieldName)}
                    checked={ignoreFilterValue?.checked}
                />
                <label htmlFor={`ignore-${fieldName}`} className="ms-2">{ignoreFilterValue.caption}</label>
            </div>
            {hasSearch &&
                <input onChange={(e: any) => setSearchValue(e.target.value, fieldName)} value={searchValue} className="list-checkbox-search"></input>
            }
            <div className={"list-checkbox with-search-container" + (ignoreFilterValue?.checked ? " filter-ignore" : '')}>
                {nullFilterValue && captionFilter(nullFilterValue?.caption) &&
                    <div className="map-hint-filters-checkbox-div">
                        <Checkbox
                            inputId={`null-${fieldName}`}
                            name={`null-${fieldName}`}
                            onChange={(event: any) => applyFilterListCheckboxValue(`null-${fieldName}`, event.checked, fieldName)}
                            checked={nullFilterValue?.checked}
                        />
                        <label htmlFor={`null-${fieldName}`} className="ms-2">{nullFilterValue.caption}</label>
                    </div>
                }
                {listValues
                    ?
                    <>
                        {listValues?.filter(listSearchFilter)?.map((listValue: any, index: any) =>
                            <>
                                {listValue.caption !== ignoreFilterValue.caption &&
                                    <div className="map-hint-filters-checkbox-div">
                                        <Checkbox
                                            inputId={`${index}${listValue.value}`}
                                            name={`${index}${listValue.value}`}
                                            onChange={(event: any) => applyFilterListCheckboxValue(listValue.value, event.checked, fieldName)}
                                            checked={listValue.checked}
                                        />
                                        <label htmlFor={`${index}${listValue.value}`} className="ms-2">{listValue.caption}</label>
                                    </div>
                                }
                            </>
                        )}
                    </>
                    :
                    <div className="map-hint-filters-checkbox-div">
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        <span>Загрузка...</span>
                    </div>
                }
                {!listValues?.filter(listSearchFilter)?.length && !captionFilter(nullFilterValue?.caption) &&
                    <div className="map-hint-filters-checkbox-div">
                        <label className="no-results">Нет результатов</label>
                    </div>
                }
            </div>
        </div>
    )
}
